import { render, staticRenderFns } from "./on-account-detail.vue?vue&type=template&id=73589d10&scoped=true&"
import script from "./on-account-detail.vue?vue&type=script&lang=ts&"
export * from "./on-account-detail.vue?vue&type=script&lang=ts&"
import style0 from "./on-account-detail.vue?vue&type=style&index=0&id=73589d10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73589d10",
  null
  
)

export default component.exports